import { createFileRoute } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import NewRuleClient from '../components/NewRuleClient'

export const Route = createFileRoute('/rules/new')({
  head: () => ({
    meta: [{ title: 'New Rule | Unbreakable' }],
  }),
  component: NewRulePage,
})

function NewRulePage() {
  return (
    <AuthGuard>
      <NewRuleClient />
    </AuthGuard>
  )
}
